import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div>
            <Link
              to="/"
              className="font-heading text-xl font-bold text-foreground-950 tracking-tight whitespace-nowrap"
            >
              Sugargoo<span className="text-primary-500">Sheet</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              Your trusted resource hub for Sugargoo spreadsheet discoveries, curated product finds, and expert shopping guides for international buyers.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              SEO Guides
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-review" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Sugargoo Review
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-shipping-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Shipping Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-coupon-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Coupons &amp; Discounts
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-warehouse-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Warehouse Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/best-sugargoo-spreadsheet" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Best Spreadsheets
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-spreadsheet-tips" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Tips &amp; Tricks
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-spreadsheet-beginners" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Beginner&apos;s Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-product-finds" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Product Finds
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap">
                  Main Website
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} SugargooSheet. All rights reserved. This is an independent information website.
          </p>
          <p className="text-xs text-foreground-400">
            Not affiliated with Sugargoo officially.
          </p>
        </div>
      </div>
    </footer>
  );
}